import React, { useState } from "react"

interface ImagePreviewProps {
    src: string
    alt?: string
    text?: string
    type?: 'image' | 'video'
}

const ImagePreview: React.FC<ImagePreviewProps> = ({ src, alt, text, type = 'image' }) => {
    const defaultImageUrl = "/assets/images/No_Image_Available.jpg";
    const [imageSrc, setImageSrc] = useState(src);
    const handleImageError = (fallbackUrl: string) => {
        setImageSrc(fallbackUrl);
    };

    return (
        <div className="flex items-center gap-3">
            {
                type === 'image' ? (
                    <img
                        src={imageSrc}
                        alt={alt}
                        onError={() => handleImageError(defaultImageUrl)}
                        className="w-10 h-10 min-w-10 min-h-10 rounded object-cover"
                    />
                ) : (
                    <video
                        className="w-10 h-10 min-w-10 min-h-10 rounded object-cover"
                    >
                        <source src={src} />
                    </video>
                )
            }
            {
                text && (
                    <span className="font-medium truncate max-w-[150px]">
                        {text}
                    </span>
                )
            }
        </div>
    )
}

export default ImagePreview;